export default class PrintText {
    protected buttons;

    constructor() {
        $(document).on('click', '.print-text__button', (event) => {
            this.toggle(event)
        })
    }

    toggle(event) {
        const button = event.currentTarget;
        const container = button.parentNode;
        const containerTextPart = button.parentNode.querySelector('.print-text__part');
        const textPart = containerTextPart.textContent;
        const isOpened = container.classList.contains('_opened');

        if (isOpened) {
            button.innerHTML = 'Развернуть';
            container.classList.remove('_opened');
        } else {
            containerTextPart.textContent = '';
            container.classList.add('_opened');
            printSmbl(containerTextPart, textPart);
            button.innerHTML = 'Свернуть';
        }

        function printSmbl(container, text) {
            let length = container.textContent.length;

            container.textContent = container.textContent + text[length];
            length++;

            if (length < text.length) {
                setTimeout(printSmbl, 3, container, text);
            }
        }
    }
}
